import React from "react";

function WebTypeCommerceDetailsStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="pt-3 mt-3">
          <h2 className="h6 pb-1 mb-3 color_grey">
            Great! Please Select Your E-Commerce Needs.
          </h2>
        </div>

        <div className="col-lg-12">
          <div className="row row-cols-1 row-cols-sm-1 g-3 g-sm-4 pb-3 pb-sm-4 mb-xl-2">
            {/* Infrastructure */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Infrastructure
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="ecommerce-infrastructure"
                onChange={handleChange}
                value={formData["ecommerce-infrastructure"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                <option value="Woocommerce">
                  Wordpress - Woocommerce (CMS)
                </option>
                <option value="Magento">Magento</option>
                <option value="Shopify">Shopify</option>
                <option value="Custom">
                  Custom Infrastructure (NextJS, ReactJS, etc.)
                </option>
                <option value="Not Sure">Not Sure</option>
              </select>
            </div>

            {/* Design Level */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Design Level
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="design-level"
                onChange={handleChange}
                value={formData["design-level"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                <option value="Customer's Request (Design Files Available).">
                  Customer's Request (Design Files Available).
                </option>
                <option value="Simple or Very Basic Design Needed.">
                  Simple or Very Basic Design Needed.
                </option>
                <option value="Custom and Professional Work Required.">
                  Custom and Professional Work Required.
                </option>
              </select>
            </div>

            {/* Site Type */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Site Type
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="ecommerce-site-type"
                onChange={handleChange}
                value={formData["ecommerce-site-type"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                <option value="B2C – Business to Consumer – lcwaikiki.com">
                  B2C – Business to Consumer – lcwaikiki.com
                </option>
                <option value="B2B – Business to Business – alibaba.com">
                  B2B – Business to Business – alibaba.com
                </option>
                <option value="C2B – Consumer to Business – priceline.com">
                  C2B – Consumer to Business – priceline.com
                </option>
                <option value="C2C – Consumer to Consumer – letgo.com">
                  C2C – Consumer to Consumer – letgo.com
                </option>
                <option value="Not Sure">Not Sure</option>
              </select>
            </div>
          </div>

          {/* Extra Options */}
          <div className="row">
            <div className="col-lg-12">
              <label className="form-label">Extra Options</label>
            </div>
            <div className="col-lg-12">
              <div className="row row-cols-1 row-cols-md-1 gy-3 gx-4">
                {[
                  { id: "xml", label: "XML Integration" },
                  { id: "multi-currency", label: "Multi-Currency" },
                  { id: "walmart-api", label: "Walmart API" },
                  { id: "etsy-api", label: "Etsy API" },
                  { id: "ebay-api", label: "Ebay API" },
                  { id: "amazon-api", label: "Amazon API" },
                  { id: "custom-api", label: "Custom API" },
                  { id: "cargo-integration", label: "Cargo Integration" },
                ].map((option) => (
                  <div className="col" key={option.id}>
                    <div className="form-check mb-0">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={option.id}
                        name="extra-options"
                        onChange={handleChange}
                        checked={
                          formData["extra-options"]?.includes(option.label) ||
                          false
                        }
                        value={option.label}
                      />
                      <label htmlFor={option.id} className="form-check-label">
                        {option.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WebTypeCommerceDetailsStep;
